import React, { useState, useEffect, useRef } from "react";

export default function Disapearable({
  as = "div",
  style = {},
  children,
  ...props
}) {
  const [opacity, setOpacity] = useState(1);
  const ref = useRef();

  useEffect(() => {
    function onScroll() {
      const { innerHeight, scrollY } = window;
      const { top } = ref.current.getBoundingClientRect();

      if (scrollY > innerHeight) {
        return;
      }

      const newOpacity =
        1 - Math.round(((1.4 * (innerHeight - top)) / innerHeight) * 100) / 100;

      setOpacity(newOpacity);
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  });

  return React.createElement(
    as,
    {
      ...props,
      ref: ref,
      style: {
        ...style,
        opacity,
      },
    },
    children,
  );
}
